/**
 * PeriodSelector — shared period picker for all report pages
 */
import React from 'react';

const PERIODS = [
  { value: 'this_month',  label: 'This Month' },
  { value: 'last_month',  label: 'Last Month' },
  { value: 'last_3m',     label: 'Last 3 Months' },
  { value: 'last_6m',     label: 'Last 6 Months' },
  { value: 'this_year',   label: 'This Year' },
];

const PeriodSelector = ({ value, onChange }) => (
  <div className="flex items-center gap-1 p-1 bg-gray-100 rounded-lg" data-testid="period-selector">
    {PERIODS.map((p) => (
      <button
        key={p.value}
        onClick={() => onChange(p.value)}
        data-testid={`period-${p.value}`}
        className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
          value === p.value
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        {p.label}
      </button>
    ))}
  </div>
);

export default PeriodSelector;
